import React from 'react';
import PropTypes from 'prop-types';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_green.css';
import { DateTime } from 'luxon';
import isDate from 'lodash.isdate';
import {
  FORMAT_DATE_TIME,
  FORMAT_DATE,
  transformDateFormatFlatPickerToLuxton
} from '../helpers/date';

const DateTimeWidget = ({ value, onChange, schema }) => (
  <Flatpickr
    data-enable-time={schema.format === 'date-time'}
    value={value}
    options={{
      dateFormat:
        schema.dateFormat ||
        (schema.format === 'date-time' ? FORMAT_DATE_TIME : FORMAT_DATE)
    }}
    onChange={date =>
      onChange(
        isDate(value)
          ? date[0]
          : DateTime.fromJSDate(date[0]).toFormat(
              transformDateFormatFlatPickerToLuxton(
                schema.dateFormat ||
                  (schema.format === 'date-time'
                    ? FORMAT_DATE_TIME
                    : FORMAT_DATE)
              )
            )
      )
    }
  />
);
DateTimeWidget.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
};
export default DateTimeWidget;



// WEBPACK FOOTER //
// ./src/components/DateTimeWidget.js